import { render, staticRenderFns } from "./OrderTypeMap.vue?vue&type=template&id=694e10b4&"
import script from "./OrderTypeMap.vue?vue&type=script&lang=js&"
export * from "./OrderTypeMap.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeMap.vue?vue&type=style&index=0&id=694e10b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports